<template>
  <div class="container mt-4 px-3">
    <h4 class="mb-3">
      <i class="bi bi-person-plus-fill text-success"></i> Create New User
    </h4>
    <div class="border-top border-success mb-4"></div>
    <div class="row">
      <!-- Left Section -->
      <div class="col-md-6">
        <div class="mb-3">
          <label class="form-label"><i class="bi bi-envelope"></i> Username</label>
          <input type="email" class="form-control" placeholder="Username" v-model="username">
        </div>

        <div class="mb-3">
          <label class="form-label"><i class="bi bi-envelope"></i> Email</label>
          <input type="email" class="form-control" placeholder="Email" v-model="email">
        </div>

        <div class="mb-3">
          <label class="form-label"><i class="bi bi-card-list"></i> First Name</label>
          <input type="text" class="form-control" placeholder="First Name" v-model="firstName">
        </div>


        <div class="mb-3">
          <label class="form-label"><i class="bi bi-card-list"></i> Last Name</label>
          <input type="text" class="form-control" placeholder="Last Name" v-model="lastName">
        </div>

        <div class="mb-3">
          <label class="form-label"><i class="bi bi-person-badge"></i> Role</label>
          <select class="form-select" v-model="role">
            <option value="User">User</option>
            <option value="Operator">Operator</option>
            <option value="Editor">Editor</option>
            <option value="Admin">Admin</option>
            <option value="Owner" v-if="[ 'Owner'].includes(userInfo.role)">Owner</option>
          </select>
        </div>

        <div class="mb-3">
          <label class="form-label"><i class="bi bi-envelope"></i> Password</label>
          <input type="password" class="form-control" placeholder="" v-model="password">
        </div>

        <!-- <div class="mb-3">
            <label class="form-label"><i class="bi bi-bookmark"></i> Note</label>
            <textarea class="form-control" rows="4" placeholder="Add a note..." v-model="note"></textarea>
          </div> -->
      </div>

      <!-- Right Section -->
      <div class="col-md-6">
        <!-- <div class="d-flex justify-content-between align-items-center mb-2">
            <label class="form-label">
              <i class="bi bi-layers"></i> Protocol
            </label>
            <button class="btn btn-primary btn-sm" :disabled="!email || !fullName">
              <i class="bi bi-plus-lg"></i> Add Application
            </button>
          </div> -->
        <div class="mb-3">
          <label class="form-label"><i class="bi bi-bookmark"></i> Note</label>
          <textarea class="form-control" rows="4" placeholder="Add a note..." v-model="note"></textarea>
        </div>
        <!-- <div class="border p-3 bg-light" style="height: 200px;">
            <p class="text-muted text-center">
              *Please fill email and fullname before adding an application
            </p>
          </div> -->
      </div>
    </div>

    <!-- Buttons -->
    <div class="d-flex justify-content-between mt-4">
      <button @click="clearDataUser()" class="btn btn-danger px-4" >
        <i class="bi bi-brush"></i> Clear
      </button>
      <button @click="createUser()" class="btn btn-secondary px-4" :disabled="!username || !firstName">
        <i class="bi bi-person-plus"></i> Create User
      </button>
    </div>
  </div>
</template>


<script>
  export default {
    components: {},

      data() {
        return {
          email: "",
          username: "",
          firstName: "",
          lastName: "",
          role: "",
          note: "",
          userInfo: {
          username: "",
          role: ""
        },
        };
      },
    methods: {
      clearDataUser(){
        this.email= "",
        this.username= "",
        this.firstName= "",
        this.lastName= "",
        this.role= "",
        this.note= ""
      },
      async createUser() {
        try {
          var accessToken = localStorage.getItem("accessToken");
          const response = await fetch(`${process.env.VUE_APP_API_URL}/auth/signup`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${accessToken}`
            },
            body: JSON.stringify({
              "username": this.username,
              "email": this.email,
              "password": this.password,
              "confirmPassword": this.password,
              "firstName": this.firstName,
              "lastName": this.lastName,
              "role": this.role //'Admin', 'Owner', 'User'
            })
          });

          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }

          const result = await response.json();
          this.$router.push('/user/listuser');

          console.log('Dashboard page created:', result);
        } catch (error) {
          console.error('Error creating dashboard page:', error);
        }
      },
    },
    created() {
      this.userInfo.username = localStorage.getItem("username");
      this.userInfo.role = localStorage.getItem("role");
    }
  }
</script>

<style scoped>
  /* Add extra styling if needed */
</style>